import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'

import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import IconButton from '@material-ui/core/IconButton'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { makeStyles, useTheme } from '@material-ui/core/styles'

const styles = (theme) => {
  const buttonSize = 59
  const buttonSizeSmall = 48
  const buttonSizeExtraSmall = 24

  return {
    carousel: {
      alignItems: 'center',
      bottom: 0,
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      left: 0,
      margin: 'auto',
      maxHeight: '100%',
      maxWidth: '100%',
      position: 'absolute',
      right: 0,
      top: 0,
    },
    controlButton: {
      color: '#ffffff',
    },
    image: {
      backgroundColor: '#ffffff',
      maxHeight: '100%',
      maxWidth: '100%',
    },
    imageControls: {
      maxWidth: `calc(100% - ${buttonSize * 3}px)`,
      [theme.breakpoints.down('sm')]: {
        maxWidth: `calc(100% - ${buttonSizeSmall * 2}px)`,
      },
      [theme.breakpoints.down('xs')]: {
        maxWidth: `calc(100% - ${buttonSizeExtraSmall * 2}px)`,
      },
    },
  }
}
const useStyles = makeStyles(styles)

export default function DeckCarousel(props) {
  const {
    controls = true,
    currentSlide = 0,
    onNextSlide,
    onPreviousSlide,
    slides = [],
  } = props

  const theme = useTheme()

  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const extraSmallScreen = useMediaQuery(theme.breakpoints.down('xs'))

  const iconButtonSize = extraSmallScreen ? 'small' : null
  let iconButtonIconSize = 'large'
  if (extraSmallScreen) {
    iconButtonIconSize = 'inherit'
  } else if (smallScreen) {
    iconButtonIconSize = 'default'
  }

  const classes = useStyles()

  return (
    <div className={classes.carousel}>
      {controls && (
        <IconButton
          className={classes.controlButton}
          onClick={onPreviousSlide}
          size={iconButtonSize}
        >
          <ArrowBackIcon fontSize={iconButtonIconSize} />
        </IconButton>
      )}

      <img
        className={clsx(classes.image, controls && classes.imageControls)}
        alt="Deck"
        src={slides[currentSlide].image}
      />

      {controls && (
        <IconButton
          className={classes.controlButton}
          onClick={onNextSlide}
          size={iconButtonSize}
        >
          <ArrowForwardIcon fontSize={iconButtonIconSize} />
        </IconButton>
      )}
    </div>
  )
}

DeckCarousel.propTypes = {
  controls: PropTypes.bool,
  currentSlide: PropTypes.number,
  onNextSlide: PropTypes.func,
  onPreviousSlide: PropTypes.func,
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
    }),
  ),
}
